import { useState, useEffect } from 'react';
import styled from 'styled-components';
import Modal from 'components/ui-components/Modal';
import Button from 'components/ui-components/Button';
import { branchTermSingular } from 'utils/terminology';
import { CloseXmark } from 'assets/icons';
import Title from 'components/ui-components/Title';

const AccountActivatedModal = ({
  modalTitle,
  modalDescription,
  modalContent,
}) => {
  const [modalOpen, setModalOpen] = useState(true);

  const accountActivated = sessionStorage.getItem('accountActivated');

  const showUsersAccount = () => {
    setModalOpen(false);
    window.location.href = `${window.location.origin}/mycef`;
  };

  useEffect(() => {
    if (!modalOpen) {
      sessionStorage.setItem('accountActivated', true);
    }
  }, [modalOpen]);

  return (
    <div className="registration-modal">
      <ActivatedModal
        isOpen={!accountActivated && modalOpen}
        closeModal={() => setModalOpen(false)}>
        <div className="fl fl-col margin-center registration-modal__container">
          <CloseButton
            label="close modal"
            handleClick={() => setModalOpen(false)}>
            <CloseXmark width="25" height="25" />
          </CloseButton>
          <Title
            icon="success"
            title={modalTitle || 'Account Created'}
            className="width-100 ta-l jc-fs fl-row mb-18 m-no-margin"
          />
          <h4 className="width-100 ta-l mt-34 mb-16">
            {modalDescription || 'Thank you for activating your CEF account'}
          </h4>
          <p className="mb-34 fs-16 fw-400 tc-secondary">
            {modalContent ||
              `If you have applied for credit, your CEF ${branchTermSingular} will need to perform a final credit check before you can pay on account. While we perform the credit check, you can still shop online and make purchases using card or PayPal.`}
          </p>
          <div className="width-100 fl fl-col-reverse jc-sb ai-c m-fl-row">
            <ViewAccountButton
              className="cef-btn cef-btn--feature cef-btn--xxl tc-cef-green"
              type="button"
              handleClick={showUsersAccount}>
              View Account
            </ViewAccountButton>
            <Button
              className="cef-btn cef-btn--feature cef-btn--xxl cef-btn--green mb-16 m-no-margin"
              type="button"
              handleClick={() => setModalOpen(false)}>
              Start Shopping
            </Button>
          </div>
        </div>
      </ActivatedModal>
    </div>
  );
};

const ViewAccountButton = styled(Button)`
  border: 2px solid #207600;

  &:hover {
    background-color: #207600;
    color: #fff;
  }
`;

const CloseButton = styled(Button)`
  position: absolute;
  top: 0;
  right: 0;
  background-color: inherit;
`;

const ActivatedModal = styled(Modal)`
  > div {
    position: relative;
    display: flex;
    align-items: center;
    width: 335px;
    padding: 1.875rem 1.25rem;
    @media only screen and (min-width: 768px) {
      width: calc(580px - 5rem);
      padding-inline: 5rem;
    }
  }
`;

export default AccountActivatedModal;
